module.exports = __webpack_public_path__ + "static/media/background2.e14b6d11.jpg";